/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tasks/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Status from './Status/index'
import Tysiav2TasksIcon from 'DesignSystem/Svgs/Tysiav2TasksIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Tasks({
  children,
  viewPath = "/App/Account/Topbar/Tabs/QuickAccess/Tab/Icon/Tasks",
  hovered,
  selected
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let globalFeatureFlagsIsNewTasksEnabledValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'feature_flags.is_new_tasks_enabled',
})
  return (<React.Fragment
>
<Tysiav2TasksIcon
  viewPath={`${viewPath}/Tysiav2TasksIcon`}
 width={16}
 height={16}
 fill2={hovered && selected ? dtColorsWhite : hovered ? dtColorsWhite : selected ? dtColorsWhite : dtColorsWhite}
/>
<fromFlow.When is={!globalFeatureFlagsIsNewTasksEnabledValueData}>
<Status
  viewPath={`${viewPath}/Status`}
 data="global.feature_flags.is_new_tasks_enabled"
/>
</fromFlow.When>
{children}
</React.Fragment>)
}